import React from 'react';
import './EventsPage.css';

const EventsPage = () => {
  return (
    <div className="events-page">
      <div className="events-intro">
        <h2>Well-Being Events</h2>
        <p>Join our upcoming workshops and events designed to support your well-being journey. Connect with peers, learn from FireUp coaches, and develop essential life-ready skills.</p>
      </div>

      <div className="events-calendar">
        <iframe
          title="Well-Being Events Calendar"
          src="https://luma.com/embed/calendar/cal-eHy4mi3X42lLQD0/events?lt=light&tag=well-being"
          width="100%"
          height="750"
          frameBorder="0"
          style={{ border: '1px solid #bfcbda88', borderRadius: '4px' }}
          allowFullScreen=""
          aria-hidden="false"
          tabIndex="0"
        ></iframe>
      </div>
    </div>
  );
};

export default EventsPage;

